import React, { useEffect, useState } from 'react'
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Container,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  useMediaQuery,
  Avatar
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { Link } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom';


const navItems = [
  { label: 'Inicio', href: '/' },
  { label: 'Calcular Renta', href: '/calcular-renta' },
  { label: 'Programa de referidos', href: '/programa-referidos' },
  { label: 'Preguntas frecuentes', href: '/preguntas-frecuentes' },
]

export default function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const toggleDrawer = () => setMobileOpen(!mobileOpen)

  return (
    <>
      <AppBar
        position="fixed"
        color="transparent"
        elevation={scrolled ? 4 : 0}
        sx={{
          transition: 'all 0.3s ease',
          backgroundColor: scrolled ? '#fff' : 'transparent',
          backdropFilter: scrolled ? 'blur(8px)' : 'none',
          borderBottom: scrolled ? '1px solid #e0e0e0' : 'none',
        }}
      >
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
            <Typography
              variant="h5"
              fontWeight="bold"
              component={Link}
              to="/"
              sx={{ textDecoration: 'none', color: 'inherit' }}
            >
              Rodaris
            </Typography>

            

            
          </Toolbar>
        </Container>
      </AppBar>

    </>
  )
}
